export const balanceConstants = {
  heading: `# Check your card balance`,
  subHeading: `#### Please fill in your **Unique Card ID** below to check your card balance.`,
  balanceText: `This can be located on the top left corner on the back of your card. It is alphanumerical and 9-10 characters long.`,
  balanceButtonText: `Check Balance`,
  balanceTableHeading: `## Balance`,
  last4text: `If your card number is '1234 **** **** 5678', enter 5678`,
  defaultValue: {
    eaid: '',
  },
  defaultPageSize: 100,
  validations: {
    eaid: {
      id: 'activationCode',
      required: 'Unique Card ID is required',
      format: `Unique Card ID is invalid`,
    },
    last4: {
      id: 'last4',
      required: 'Last 4 digits is required',
      format: 'Last 4 digits is required',
    },
  }
};
